
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Navbar() {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
    { path: '/dashboard', label: '首页', icon: 'ri-home-line' },
    { path: '/activities', label: '工作台', icon: 'ri-calendar-event-line' },
    { path: '/calendar', label: '营销日历', icon: 'ri-calendar-2-line' },
    { path: '/analytics', label: '数据分析', icon: 'ri-bar-chart-line' }
  ];

  const isActive = (path: string) => {
    return currentPath === path;
  };

  return (
    <nav className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-8">
          <Link to="/" className="flex items-center space-x-3">
            <img src="/logo.png" alt="logo" className="w-10 h-10" />
            <h1 className="text-xl font-bold text-gray-900">
              CLC 营销平台
            </h1>
          </Link>
          <div className="flex space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <i className={`${item.icon} mr-2`}></i>
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <Button variant="outline" size="sm">
            <i className="ri-notification-line mr-2"></i>
            通知
          </Button>
          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
            <i className="ri-user-line text-white text-sm"></i>
          </div>
        </div>
      </div>
    </nav>
  );
}
